import axiosInstance from "../../../../interceptors/axiosInstance";
import { AxiosResponse } from "axios";
import { GenerarCertificadoPortabilidadDto } from "../interfaces/GenerarCertificadoPortabilidadRequest";

const generarCertificado = async (body: GenerarCertificadoPortabilidadDto): Promise<any> => {

    const headers = {
        'X-Hide-Toast': 'true',
        "X-Hide-Loader" : 'true',
    };

    try {
        const response: AxiosResponse = await axiosInstance.post(`siscred-api-reportes/v1/portabilidad/generarcertificadoliquidacion`, body, { headers: headers });
        return response;
    } catch (error) {
        throw error;
    }
}

export {
    generarCertificado,
};
